import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { NewmemberService } from '@app/services/newmember/newmember.service';
import { MemberService } from '@app/services/member.service';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';

@Component({
  selector: 'app-newmember',
  templateUrl: './newmember.component.html',
  styleUrls: ['./newmember.component.css'],

})

export class NewmemberComponent implements OnInit, OnDestroy {
  // maxYear ska vara dynamiskt
  boundaries = { minYear: '1700', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.boundaries);
  public maskdatum = [/[129]/, /[?0789]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  form: FormGroup;
  members = [];
  activeBtn = 'Kontrollera';
  infoText = '';
  institutionid;
  institution;
  subscriptions: Subscription[] = [];
  controlBtnActive = false;

  constructor(
    private fb: FormBuilder,
    private location: Location,
    private router: Router,
    private newmemberService: NewmemberService,
    private memberService: MemberService,
    private activatedRoute: ActivatedRoute) {
  }
  @HostListener('window:unload', ['$event']) unloadHandler(event: Event) {
    event.stopImmediatePropagation();
  }

  clear() {
    this.infoText = '';
    this.form.reset();
    this.members = [];
    this.controlBtnActive = false;
    this.activeBtn = 'Kontrollera';
  }

  ngOnInit() {
    this.router.events.subscribe(r => {
      if (r instanceof NavigationEnd) {
        this.clear();
      }
    });
    this.activatedRoute.params.subscribe(params => {
      if (params) {
        this.institutionid = params.id;
      }
    });
    this.form = this.fb.group({
      Birth: ['', Validators.required]
    }
    );

    if (this.newmemberService.birthday) {
      this.form.get('Birth').setValue(this.newmemberService.birthday);
      this.checkUser();
    }
  }

  dateSelected() {

  }
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  setBtn() {
    this.activeBtn = 'Kontrollera';
    this.newmemberService.setBirthday(this.form.value.Birth);
  }

  checkUser() {
    this.newmemberService.newbirthday.next(this.form.value.Birth);
    this.subscriptions.push(this.memberService.getMembersByBirthDateAsync(this.form.value.Birth).subscribe(data => {
      this.members = data;
      if (this.members.length > 0) {
        this.infoText = 'Det finns ' + this.members.length + ' personer i systemet med aktuellt födelsedatum.';
      } else {
        this.infoText = 'Det finns ingen person i systemet med aktuellt födelsedatum.';
      }
    }));
    this.activeBtn = 'Fortsätt';
  }

  continue() {
    this.activeBtn = 'Kontrollera';
    this.router.navigate(['/addmember'], { queryParams: { action: 'new', birthday: this.form.get('Birth').value, institutionid: this.institutionid } });
  }

  onSubmit() {
  }

  cancel() {
    this.location.back();
  }
}
